import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import themeSlice from './slices/themeSlice';
import uiSlice from './slices/uiSlice';
import { api } from '../services/api';
import { aiApi } from '../services/aiApi';
import errorMiddleware from '../middleware/errorMiddleware';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    theme: themeSlice,
    ui: uiSlice,
    [api.reducerPath]: api.reducer,
    [aiApi.reducerPath]: aiApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setToken'],
        ignoredActionPaths: [
          'payload.token',
          'meta.baseQueryMeta.request',
          'meta.baseQueryMeta.response',
        ],
      },
    })
      .concat(api.middleware)
      .concat(aiApi.middleware)
      .concat(errorMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
